import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { Button } from '@/components/atoms/Button';
import { ActivityCard } from '@/components/molecules/ActivityCard';
import ActivityModal from '@/components/molecules/ActivityModal';
import ViewDataWrapper from '@/components/molecules/ViewDataWrapper';
import api from '@/services/apiSgft';
import { ActivityData } from '@/types/ActivityData';
import { userCanUpdateActivity } from '@/utils/handleSavePermissions';

import ErrorIcon from '../../assets/icons/error.svg';

const Activity = () => {
	const [isOpenCreate, setIsOpenCreate] = useState(false);

	const getActivitiesData = async () => {
		try {
			const response = await api.get('/activity/all');
			return response.data as ActivityData[];
		} catch (e) {
			toast.error('Erro ao carregar As Atividades!', {
				theme: 'colored',
				toastId: 'error',
			});
		}
	};

	const { data, isLoading, isError } = useQuery(
		['get-all-activities-data'],
		getActivitiesData,
	);

	const EmptyState = () => {
		return (
			<div className="h-full w-[95%] px-[1%]">
				<div className="flex h-full w-full flex-col items-center justify-center rounded-md">
					<img src={ErrorIcon} alt="Ícone de erro" className="w-24" />
					<div className="flex flex-col items-center text-center">
						Nenhuma atividade encontrada!
					</div>
				</div>
			</div>
		);
	};

	const isAllowedToUpdateActivity = userCanUpdateActivity();

	return (
		<div className="relative flex h-[calc(100%-3rem)] max-h-screen w-full flex-col items-start">
			<div className="mt-6 flex w-full justify-between">
				<div className="mb-2 px-3 font-graphie text-2xl font-bold text-primary">
					Tipos de Atividades
				</div>
				<Button
					className="h-7 w-40 rounded-full text-xs text-white"
					onClick={() => setIsOpenCreate(true)}
					disabled={isLoading || !isAllowedToUpdateActivity}
				>
					+ Adicionar
				</Button>
			</div>
			<ViewDataWrapper isLoading={isLoading} isError={isError}>
				<div className="custom-scrollbar flex h-[80vh] w-full flex-col gap-4 overflow-auto rounded-md px-5">
					{data?.length ? (
						data.map((el) => {
							return <ActivityCard key={el.id} activity={el} />;
						})
					) : (
						<EmptyState />
					)}
				</div>
			</ViewDataWrapper>
			{isOpenCreate && (
				<ActivityModal
					isOpen={isOpenCreate}
					onClose={() => setIsOpenCreate(false)}
					type={'create'}
				/>
			)}
		</div>
	);
};

export default Activity;
